import React from "react";
import { ClipboardCheckIcon, CompassIcon, MapIcon, NotebookPenIcon, SmartphoneIcon, BoxIcon } from "lucide-react";
import { tools, ToolIcon } from "../../data/content";
import { SectionHeading } from "../ui/SectionHeading";
import { TransformCta } from "../ui/TransformCta";
const iconMap: Record<ToolIcon, BoxIcon> = {
  map: MapIcon,
  checklist: ClipboardCheckIcon,
  compass: CompassIcon,
  notes: NotebookPenIcon,
  phone: SmartphoneIcon
};
export function Tools() {
  return <section className="bg-white px-5 py-16 sm:py-24" aria-labelledby="tools-title" data-id="element-300" data-mp="23smsewbccphy">
      <div id="tools-title" data-id="element-301" data-mp="23qtkzeswm18w">
        <SectionHeading title={<>
              And that's not all… <em className="italic text-brand-600" data-id="element-303" data-mp="1yrh3l9ksxmdp">practical tools</em> inside your system
            </>} data-id="element-302" data-mp="1yt0j2xymvtef" />
      </div>

      <ul className="mx-auto mt-10 max-w-3xl divide-y divide-brand-100 rounded-3xl bg-cream px-5 ring-1 ring-brand-100 sm:px-8" data-id="element-304" data-mp="1psvl1efby7cx">
        {tools.map(({
        icon,
        title,
        text
      }) => {
        const Icon = iconMap[icon];
        return <li key={title} className="flex gap-4 py-5" data-id="element-305" data-mp="158obofej1bth">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-brand-700 text-white" data-id="element-306" data-mp="19zwl3bfuwx6n">
                <Icon className="h-6 w-6" aria-hidden="true" data-id="element-307" data-mp="w9kslbfd0wez" />
              </span>
              <div data-id="element-308" data-mp="109v5z95hep3v">
                <h3 className="text-lg font-extrabold text-ink" data-id="element-309" data-mp="10bem8zr5105n">{title}</h3>
                <p className="mt-1 text-[17px] leading-snug text-ink/70" data-id="element-310" data-mp="1nzfr9yp3xygb">{text}</p>
              </div>
            </li>;
      })}
      </ul>

      <TransformCta label="Get access to the complete system" data-id="element-311" data-mp="1sxqxlzg71qts" />
    </section>;
}